<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <section class="section white-panel mb3p">
          <h2 class="fs16 font-weight-bold mt12 mb12">洗車プリペイドとは？</h2>
          <table class="table w100p fs12 line-height1_7">
            <tbody>
              <tr>
                <td class="fs14 pt8 pl4 pb8 pr4 w30p va-top"><img src="/lib/images/img_carwash_1.png" width="90"></td>
                <td class="fs14 pt8 pb8 pr4">
                  <p class="font-weight-bold">洗車に使えるアプリ専用のプリペイド機能です。</p>
                  <p>【コスモの公式】アプリのお客様だけが使えるオトクなサービスです。</p>
                </td>
              </tr>
              <tr>
                <td class="fs14 pt8 pl4 pb8 pr4 va-top"><img src="/lib/images/img_carwash_2.png" width="90"></td>
                <td class="fs14 pt8 pb8 pr4">
                  <p class="font-weight-bold">【特徴1】お得にチャージ！</p>
                  <p>都度払いよりお得に洗車ができます！</p>
                </td>
              </tr>
              <tr>
                <td class="fs14 pt8 pl4 pb8 pr4 va-top"><img src="/lib/images/img_carwash_3.png" width="90"></td>
                <td class="fs14 pt8 pb8 pr4">
                  <p class="font-weight-bold">【特徴2】支払いがスマート</p>
                  <p>アプリに表示されるQRコードをかざすだけで、支払いがスマートに完了！</p>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section class="section white-panel mb3p">
          <h2 class="fs16 font-weight-bold mt12 mb12">洗車プリペイドの使い方</h2>
          <h2 class="fs14 font-weight-bold mb4">＜チャージする＞</h2>
          <table class="table w100p fs12 line-height1_7 mb20">
            <tbody>
              <tr>
                <td class="fs14 pt8 pl4 pb8 pr4 w30p va-top"><img src="/lib/images/img_carwash_2.png" width="90"></td>
                <td class="fs14 pt8 pb8 pr4">
                  <p>クレジットカードを使ってアプリにチャージ！</p>
                </td>
              </tr>
            </tbody>
          </table>
          <h2 class="fs14 font-weight-bold mb4">＜使う＞ドライブスルー洗車</h2>
          <table class="table w100p fs12 line-height1_7 mb20">
            <tbody>
              <tr>
                <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4 w30p va-top"><img src="/lib/images/img_carwash_1.png" width="90"></td>
                <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4">
                  <p>1. お支払い方法で「スマホアプリ」を選ぶ</p>
                </td>
              </tr>
              <tr>
                <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4 va-top"><img src="/lib/images/img_carwash_3.png" width="90"></td>
                <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4">
                  <p>2. 洗車プリペイドのQRコードをかざす</p>
                </td>
              </tr>
              <tr>
                <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4 va-top"><img src="/lib/images/img_carwash_4.png" width="90"></td>
                <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4">
                  <p>3. 洗車メニューを選ぶ</p>
                </td>
              </tr>
              <tr>
                <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4 va-top"><img src="/lib/images/img_carwash_5.png" width="90"></td>
                <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4">
                  <p>4. 案内に従い車を洗車機へ</p>
                </td>
              </tr>
            </tbody>
          </table>
          <h2 class="fs14 font-weight-bold mb4">＜使う＞手洗い・機械洗車</h2>
          <table class="table w100p fs12 line-height1_7 mb20">
            <tbody>
              <tr>
                <td class="fs14 pt8 pl4 pb8 pr4 w30p va-top"><img src="/lib/images/img_carwash_3.png" width="90"></td>
                <td class="fs14 pt8 pb8 pr4">
                  <p>お支払いの際に、スタッフに洗車プリペイドであることをお伝えください</p>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section class="section white-panel mb3p">
          <h2 class="fs16 font-weight-bold mt12 mb12">洗車プリペイドご利用の注意事項</h2>
          <div class="bg-gray1 pd12 mt20 mb20">
            <p class="mb8 fs14"><strong>特に下記の点にご注意ください</strong></p>
            <ul class="fs14 line-height1_7 ul-disc-blue pl20">
              <li>残高の有効期限はチャージから180日です</li>
              <li>チャージ時に指定された店舗でのみ使えます</li>
              <li>払い戻しはできません</li>
            </ul>
          </div>
        </section>
      </article>
    </div>
    <!-- ネイティブからJSを実行して洗車TOPへ戻るために、クエリパラメータを格納する。 -->
    <input id="tsid" type="hidden" name="tsid" v-bind:value="this.$route.query.tsid">
    <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="this.$route.query.popinfoid">
    <input id="otoken" type="hidden" name="otoken" v-bind:value="this.$route.query.otoken">
    <input id="authid" type="hidden" name="authid" v-bind:value="this.$route.query.authid">
    <input id="ss_code" type="hidden" name="ss_code" v-bind:value="this.$route.query.ss_code">
    <input id="x_cls_app_version" type="hidden" name="x_cls_app_version" v-bind:value="this.$route.query.x_cls_app_version">
    <input id="x_cls_os" type="hidden" name="x_cls_os" v-bind:value="this.$route.query.x_cls_os">
    <input id="x_cls_os_version" type="hidden" name="x_cls_os_version" v-bind:value="this.$route.query.x_cls_os_version">
    <input id="dpi" type="hidden" name="dpi" v-bind:value="this.$route.query.dpi">
    <input id="device_pixel_ratio" type="hidden" name="device_pixel_ratio" v-bind:value="this.$route.query.device_pixel_ratio">
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    // [eventTrack]
    this.nativePVset('ABOUT_CARWASH_CARD')
  },
  components: {
  }
}
</script>
